import { PrivateRoute } from 'components'
import { LocationPaths } from 'location.types'
import { RouteObject } from 'react-router'

export const root: RouteObject = {
  lazy: async () => ({
    Component: (await import('components/PageLayout/PageLayout')).PageLayout
  }),
  children: [
    {
      path: LocationPaths.Questionnaire,
      lazy: async () => ({
        Component: (await import('screens/Survey')).QuestionnaireRoute
      })
    },
    {
      path: LocationPaths.MfaChallenge,
      lazy: async () => ({ Component: (await import('screens/MfaChallenge')).MfaChallenge })
    },
    {
      path: LocationPaths.DownloadApp,
      lazy: async () => ({
        Component: (await import('screens/Shared/DownloadApp')).DownloadApp
      })
    },
    {
      element: <PrivateRoute />,
      children: [
        {
          path: LocationPaths.HealthQuestionnaire,
          lazy: async () => ({ Component: (await import('screens/Survey')).SurveyScreen })
        },
        {
          path: LocationPaths.InsuranceQuestionnaireV2,
          lazy: async () => ({
            Component: (await import('screens/InsuranceQuestionnaire')).InsuranceQuestionnaireScreen
          })
        },
        {
          path: LocationPaths.FreeVideoCall,
          lazy: async () => ({ Component: (await import('screens/FreeVideoCall')).FreeVideoCall })
        },
        {
          path: LocationPaths.ScheduleCall,
          lazy: async () => ({
            Component: (await import('screens/ScheduleCall')).ScheduleCallScreen
          })
        },
        {
          path: LocationPaths.AddressState,
          lazy: async () => ({ Component: (await import('screens/AddressState')).AddressState })
        },
        {
          path: LocationPaths.Checkout,
          lazy: async () => ({ Component: (await import('screens/Checkout')).Checkout })
        },
        {
          path: LocationPaths.Upgrade,
          lazy: async () => ({ Component: (await import('screens/Upgrade')).Upgrade })
        }
      ]
    }
  ]
}
